import { DbConnection } from '../module_bindings_control';
import { CONTROL_PLANE_HOST, CONTROL_PLANE_MODULE, SPACETIMEDB_PROTOCOL } from '../config';
import { store, adminActions, dataActions } from '../app/store';

let connection: DbConnection | null = null;

const SUBSCRIBE_QUERIES = [
  'SELECT * FROM user',
  'SELECT * FROM coin_transaction',
  'SELECT * FROM purchase_history',
  'SELECT * FROM active_match_directory',
  'SELECT * FROM game_record',
  'SELECT * FROM global_chat_message',
  'SELECT * FROM chat_rate_limit',
  'SELECT * FROM matchmaking_queue',
  'SELECT * FROM store_item',
  'SELECT * FROM store_bundle',
  'SELECT * FROM bundle_item',
  'SELECT * FROM store_promo',
  'SELECT * FROM user_subscription',
  'SELECT * FROM ranked_season',
  'SELECT * FROM achievement',
];

function syncAllTables(conn: DbConnection) {
  store.dispatch(dataActions.setUsers(Array.from(conn.db.user.iter())));
  store.dispatch(dataActions.setCoinTransactions(Array.from(conn.db.coinTransaction.iter())));
  store.dispatch(dataActions.setPurchaseHistory(Array.from(conn.db.purchaseHistory.iter())));
  store.dispatch(dataActions.setActiveMatches(Array.from(conn.db.activeMatchDirectory.iter())));
  store.dispatch(dataActions.setGameRecords(Array.from(conn.db.gameRecord.iter())));
  store.dispatch(dataActions.setGlobalChat(Array.from(conn.db.globalChatMessage.iter())));
  store.dispatch(dataActions.setChatRateLimits(Array.from(conn.db.chatRateLimit.iter())));
  store.dispatch(dataActions.setMatchmakingQueue(Array.from(conn.db.matchmakingQueue.iter())));
  store.dispatch(dataActions.setStoreItems(Array.from(conn.db.storeItem.iter())));
  store.dispatch(dataActions.setStoreBundles(Array.from(conn.db.storeBundle.iter())));
  store.dispatch(dataActions.setBundleItems(Array.from(conn.db.bundleItem.iter())));
  store.dispatch(dataActions.setStorePromos(Array.from(conn.db.storePromo.iter())));
  store.dispatch(dataActions.setUserSubscriptions(Array.from(conn.db.userSubscription.iter())));
  store.dispatch(dataActions.setRankedSeasons(Array.from(conn.db.rankedSeason.iter())));
  store.dispatch(dataActions.setAchievements(Array.from(conn.db.achievement.iter())));
}

function registerCallbacks(conn: DbConnection) {
  // User
  conn.db.user.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertUser(row)); });
  conn.db.user.onDelete((_ctx, row) => { store.dispatch(dataActions.removeUser(row)); });

  // Coin Transaction
  conn.db.coinTransaction.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertCoinTransaction(row)); });
  conn.db.coinTransaction.onDelete((_ctx, row) => { store.dispatch(dataActions.removeCoinTransaction(row)); });

  // Purchase History
  conn.db.purchaseHistory.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertPurchaseHistory(row)); });
  conn.db.purchaseHistory.onDelete((_ctx, row) => { store.dispatch(dataActions.removePurchaseHistory(row)); });

  // Active Match Directory
  conn.db.activeMatchDirectory.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertActiveMatch(row)); });
  conn.db.activeMatchDirectory.onDelete((_ctx, row) => { store.dispatch(dataActions.removeActiveMatch(row)); });

  // Game Record
  conn.db.gameRecord.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertGameRecord(row)); });
  conn.db.gameRecord.onDelete((_ctx, row) => { store.dispatch(dataActions.removeGameRecord(row)); });

  // Global Chat
  conn.db.globalChatMessage.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertGlobalChat(row)); });
  conn.db.globalChatMessage.onDelete((_ctx, row) => { store.dispatch(dataActions.removeGlobalChat(row)); });

  // Chat Rate Limit
  conn.db.chatRateLimit.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertChatRateLimit(row)); });
  conn.db.chatRateLimit.onDelete((_ctx, row) => { store.dispatch(dataActions.removeChatRateLimit(row)); });

  // Matchmaking Queue
  conn.db.matchmakingQueue.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertMatchmakingQueue(row)); });
  conn.db.matchmakingQueue.onDelete((_ctx, row) => { store.dispatch(dataActions.removeMatchmakingQueue(row)); });

  // Store Item
  conn.db.storeItem.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertStoreItem(row)); });
  conn.db.storeItem.onDelete((_ctx, row) => { store.dispatch(dataActions.removeStoreItem(row)); });

  // Store Bundle
  conn.db.storeBundle.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertStoreBundle(row)); });
  conn.db.storeBundle.onDelete((_ctx, row) => { store.dispatch(dataActions.removeStoreBundle(row)); });

  // Bundle Item
  conn.db.bundleItem.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertBundleItem(row)); });
  conn.db.bundleItem.onDelete((_ctx, row) => { store.dispatch(dataActions.removeBundleItem(row)); });

  // Store Promo
  conn.db.storePromo.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertStorePromo(row)); });
  conn.db.storePromo.onDelete((_ctx, row) => { store.dispatch(dataActions.removeStorePromo(row)); });

  // User Subscription
  conn.db.userSubscription.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertUserSubscription(row)); });
  conn.db.userSubscription.onDelete((_ctx, row) => { store.dispatch(dataActions.removeUserSubscription(row)); });

  // Ranked Season
  conn.db.rankedSeason.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertRankedSeason(row)); });
  conn.db.rankedSeason.onDelete((_ctx, row) => { store.dispatch(dataActions.removeRankedSeason(row)); });

  // Achievement
  conn.db.achievement.onInsert((_ctx, row) => { store.dispatch(dataActions.upsertAchievement(row)); });
  conn.db.achievement.onDelete((_ctx, row) => { store.dispatch(dataActions.removeAchievement(row)); });
}

const TOKEN_KEY = 'admin_spacetimedb_token';

export function connect(): void {
  if (connection) return;

  store.dispatch(adminActions.setConnectionStatus('connecting'));

  const savedToken = localStorage.getItem(TOKEN_KEY);

  const builder = DbConnection.builder()
    .withUri(`${SPACETIMEDB_PROTOCOL}://${CONTROL_PLANE_HOST}`)
    .withModuleName(CONTROL_PLANE_MODULE)
    .onConnect((conn, identity, token) => {
      console.log('[Admin] Connected to control-plane, identity:', identity.toHexString());
      // Save token so identity persists across reloads
      if (token) {
        localStorage.setItem(TOKEN_KEY, token);
      }
      store.dispatch(adminActions.setConnectionStatus('connected'));
      store.dispatch(adminActions.setAdminIdentity(identity.toHexString()));

      // Register live callbacks before subscribing
      registerCallbacks(conn);

      // Subscribe to all public tables
      conn.subscriptionBuilder()
        .onApplied(() => {
          console.log('[Admin] Subscription applied, syncing tables...');
          syncAllTables(conn);
        })
        .onError((ctx) => {
          console.error('[Admin] Subscription error:', ctx);
        })
        .subscribe(SUBSCRIBE_QUERIES);
    })
    .onDisconnect(() => {
      console.log('[Admin] Disconnected from control-plane');
      store.dispatch(adminActions.setConnectionStatus('disconnected'));
      connection = null;
    })
    .onConnectError((_ctx) => {
      console.error('[Admin] Connection error');
      store.dispatch(adminActions.setConnectionStatus('error'));
      connection = null;
    });

  if (savedToken) {
    builder.withToken(savedToken);
  }

  connection = builder.build();
}

export function disconnect(): void {
  if (connection) {
    connection.disconnect();
    connection = null;
  }
  store.dispatch(adminActions.setConnectionStatus('disconnected'));
}

export function getConnection(): DbConnection | null {
  return connection;
}
